import { ShouldRevalidateFunctionArgs } from "react-router-dom";

const basePath = "/:prefix/products/:vbid";

export const productRoutes = {
  // Do not use an index route. It will break my courses which calls this manually
  path: basePath,
  async lazy() {
    const { Component, loader, action } = await import("./lazyRoute.ts");
    return { Component, loader, action };
  },
  // Selecting a variant in a Supply With Attributes syncs the URL via setSearchParams,
  // which by default revalidates this route's loader on every pick even though nothing
  // needs refetching. Only skip revalidation when variantId is the sole thing that
  // changed; every other case (isbn/asset/scope navigation, add-to-cart submissions,
  // etc.) keeps the router's normal default behavior untouched.
  shouldRevalidate: (args: ShouldRevalidateFunctionArgs) => {
    const { currentUrl, nextUrl, defaultShouldRevalidate } = args;
    const variantIdChanged =
      currentUrl.searchParams.get("variantId") !==
      nextUrl.searchParams.get("variantId");
    if (!variantIdChanged) {
      return defaultShouldRevalidate;
    }

    const currentParams = new URLSearchParams(currentUrl.search);
    const nextParams = new URLSearchParams(nextUrl.search);
    currentParams.delete("variantId");
    nextParams.delete("variantId");

    const onlySupplyVariantChanged =
      currentUrl.pathname === nextUrl.pathname &&
      currentParams.toString() === nextParams.toString();

    return onlySupplyVariantChanged ? false : defaultShouldRevalidate;
  },
  children: [
    {
      path: `marketplace/:sku`,
      async lazy() {
        const { marketplaceLoader } = await import("./lazyRoute.ts");
        return { loader: marketplaceLoader };
      },
    },
  ],
};
